module.exports = __webpack_public_path__ + "f20eda1539ce74fbf0d4e7474ff7d49a.svg";